module.exports = __webpack_public_path__ + "img/tablet-neck-11_290x18.88a0f50a.png";